import { render } from "./FavoriteItem.vue?vue&type=template&id=d5ebdcc0&scoped=true"
import script from "./FavoriteItem.vue?vue&type=script&lang=js"
export * from "./FavoriteItem.vue?vue&type=script&lang=js"

import "./FavoriteItem.vue?vue&type=style&index=0&id=d5ebdcc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ebdcc0"]])

export default __exports__